export default "__VITE_ASSET__DZDyxJG8__"